var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m442.711 501.534c0 5.78-4.686 10.465-10.465 10.465h-352.491c-5.78 0-10.465-4.686-10.465-10.465v-491.069c-.001-5.779 4.685-10.465 10.465-10.465h352.491c5.78 0 10.465 4.686 10.465 10.465z",
    fill: "#f9f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.245 0h-21.316c5.78 0 10.466 4.686 10.466 10.466v491.069c0 5.78-4.686 10.466-10.466 10.466h21.316c5.78 0 10.465-4.686 10.465-10.466v-491.069c.001-5.78-4.685-10.466-10.465-10.466z",
    fill: "#dddaec"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m295.688 378.479h-163.628c-4.266 0-7.724-3.458-7.724-7.724s3.458-7.724 7.724-7.724h163.629c4.266 0 7.724 3.458 7.724 7.724s-3.458 7.724-7.725 7.724z",
    fill: "#21386b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m295.688 420.538h-163.628c-4.266 0-7.724-3.458-7.724-7.724s3.458-7.724 7.724-7.724h163.629c4.266 0 7.724 3.458 7.724 7.724s-3.458 7.724-7.725 7.724z",
    fill: "#21386b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m295.688 462.597h-163.628c-4.266 0-7.724-3.458-7.724-7.724s3.458-7.724 7.724-7.724h163.629c4.266 0 7.724 3.458 7.724 7.724-.001 4.267-3.458 7.724-7.725 7.724z",
    fill: "#21386b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m389.872 93.123h-248.888c-4.929 0-8.925-3.996-8.925-8.925v-28.126c0-4.929 3.996-8.925 8.925-8.925h248.888c4.929 0 8.925 3.996 8.925 8.925v28.126c.001 4.929-3.995 8.925-8.925 8.925z",
    fill: "#95d6a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.872 47.146h-20.954c4.929 0 8.925 3.996 8.925 8.925v28.126c0 4.929-3.996 8.925-8.925 8.925h20.954c4.929 0 8.925-3.996 8.925-8.925v-28.125c.001-4.929-3.995-8.926-8.925-8.926z",
    fill: "#78c2a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.888 328.695h212.383c.843 0 1.526-.683 1.526-1.526v-164.863c0-.843-.683-1.526-1.526-1.526h-212.383z",
    fill: "#dddaec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.056 160.78v167.916h22.216c.843 0 1.526-.683 1.526-1.526v-164.864c0-.843-.683-1.526-1.526-1.526z",
    fill: "#d0cee7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m406.521 218.691c0 4.266-3.458 7.724-7.724 7.724h-234.505c-4.266 0-7.724-3.458-7.724-7.724s3.458-7.724 7.724-7.724h234.505c4.267 0 7.724 3.458 7.724 7.724z",
    fill: "#78c2a4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m406.521 270.783c0 4.266-3.458 7.724-7.724 7.724h-234.505c-4.266 0-7.724-3.458-7.724-7.724s3.458-7.724 7.724-7.724h234.505c4.267 0 7.724 3.458 7.724 7.724z",
    fill: "#78c2a4"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m326.275 336.42c-4.266 0-7.724-3.458-7.724-7.724v-167.916c0-4.266 3.458-7.724 7.724-7.724s7.724 3.458 7.724 7.724v167.916c-.001 4.266-3.458 7.724-7.724 7.724z",
    fill: "#78c2a4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m257.413 336.42c-4.266 0-7.724-3.458-7.724-7.724v-167.916c0-4.266 3.458-7.724 7.724-7.724s7.724 3.458 7.724 7.724v167.916c-.001 4.266-3.458 7.724-7.724 7.724z",
    fill: "#78c2a4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m184.888 328.695h-51.303c-.843 0-1.526-.683-1.526-1.526v-164.863c0-.843.683-1.526 1.526-1.526h51.303z",
    fill: "#95d6a4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.8012566dfc3ab22f8b360bad06c0c29a.svg";
export { ForwardRef as ReactComponent };